import React from "react"
import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.css';

function Footer() {
    return (<>
        <footer>
            <div className="container-fluid">
                <div className="tds-copyright">
                    <p>© {(new Date().getFullYear())} {localStorage.getItem("PMSSource") !== "" && localStorage.getItem("PMSSource") === "CRX" ? "Transaction Data Systems, Inc.. " : "RX30."} All rights reserved.</p>
                </div>
            </div>
        </footer>
    </>
    )


}

export default Footer;